import config from '@/config';
import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export const useBulkUpdateDeviations = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading } = useMutation(values => api.base
        .post(`${config.appUrls.tasks}/api/CapacityPlanning/BulkUpdateDeviations`, values)
        .then(res => res.data), {
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { bulkUpdateDeviations: mutateAsync, isLoading };
};
